<!--SKU编辑  -->
<template>
	<el-dialog title="SKU信息" :visible.sync="dialogVisible" :close-on-click-modal="false"
		:close-on-press-escape="false" :modal-append-to-body="false" width="600px">
		<div class="form-box">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px">

				<el-form-item label="名称" prop="skuName">
					<el-input v-model.trim="ruleForm.skuName" maxlength="10"></el-input>
				</el-form-item>
				<el-form-item label="全称" prop="skuFullName">
					<el-input v-model.trim="ruleForm.skuFullName" maxlength="10"></el-input>
				</el-form-item>
				<el-form-item label="编码" prop="skuCode">
					<el-input v-model.trim="ruleForm.skuCode" maxlength="5"></el-input>
				</el-form-item>
				<el-form-item label="SAP编号" prop="sapNo">
					<el-input v-model.trim="ruleForm.sapNo" maxlength="20"></el-input>
				</el-form-item>
				<el-form-item label="条码" prop="barcode">
					<el-input v-model.trim="ruleForm.barcode" maxlength="20"></el-input>
				</el-form-item>
				<el-form-item label="规格" prop="format">
					<el-input v-model.trim="ruleForm.format" maxlength="3"></el-input>
				</el-form-item>
				<el-form-item label="标题" prop="skuColor" class="mb0">
					<div class="flex">
						<el-color-picker v-model="ruleForm.skuColor"></el-color-picker>
						<div class="mt20 ml10">(RGB)</div>
					</div>
				</el-form-item>
				<el-form-item class="mt10">
					<el-checkbox v-model="ruleForm.defaultFlag">是否默认SKU</el-checkbox>
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model.trim="ruleForm.remark" type="textarea" maxlength="100" :rows="2"></el-input>
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button  size="small" @click="cancle">取 消</el-button>
			<el-button  size="small" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import {
		debounce
	} from '@/utils/debounce'
	export default {
		data() {
			return {
				dialogVisible: false,
				ruleForm: {
					remark: "",
					skuCode: "",
					skuColor: "",
					defaultFlag: "",
					skuName: "",
					skuFullName: "",
					barcode: "",
					format: "",
					skuId: "",
					sapNo: "",
				},
				rules: {
					format: [
						{
							pattern: /^[1-9]\d*$/,
							message: '请输入数字,首位不能输0',
							trigger: 'blur'
						},
						{
							required: true,
							message: '请输入规格',
							trigger: 'blur'
						},
					],
					skuName: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}, ],
					skuFullName: [{
						required: true,
						message: '请输入全称',
						trigger: 'blur'
					}, ],
					skuCode: [{
							required: true,
							message: '请输入编码',
							trigger: 'blur'
						},
						{
							pattern: /^[A-Z0-9]{1,5}$/,
							message: '请输入5位以内大写英文、数字',
							trigger: 'blur'
						},

					],
					skuColor: [{
						required: true,
						message: '请选择颜色',
						trigger: 'blur'
					}, ],
					sapNo: [
						{
							required: true,
							message: '请输入SAP编号',
							trigger: 'blur'
						},
						{
							pattern: /^[0-9A-Za-z]+$/,
							message: '请输入数字和字母',
							trigger: 'blur'
						}
					],
					barcode: [
						{
							required: true,
							message: '请输入条码',
							trigger: 'blur'
						},
						{
							pattern: /^[0-9A-Za-z]+$/,
							message: '请输入数字和字母',
							trigger: 'blur'
						}
					],
				}
			}
		},
		created() {

		},
		methods: {
			init(val) {
				this.dialogVisible = true;
				this.$nextTick(() => {
					this.$refs.ruleForm.resetFields();
					this.ruleForm.remark = '';
					this.ruleForm.defaultFlag = false;
					delete this.ruleForm.skuId;
					if (val) {
						this.ruleForm = {
							skuName: val.skuName,
							skuFullName: val.skuFullName,
							skuCode: val.skuCode,
							skuColor: val.skuColor,
							defaultFlag: val.defaultFlag == 1 ? true : false,
							remark: val.remark,
							skuId: val.skuId,
							sapNo: val.sapNo,
							barcode: val.barcode,
							format: val.format
						}
					}
				})
			},
			// 保存
			submitForm: debounce(function () {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.$confirm('是否确认保存？', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
						}).then(() => {
							if (!this.ruleForm.skuId) {
								this.addRow()
							} else {
								this.updateRow()
							}
						}).catch(() => {});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			}, 1000, true),

			// 新增
			addRow() {
				let that = this;
				that.$request.post(
						"skuAdd",
						true, {
							skuName: that.ruleForm.skuName,
							skuFullName: that.ruleForm.skuFullName,
							skuCode: that.ruleForm.skuCode,
							skuColor: that.ruleForm.skuColor,
							defaultFlag: that.ruleForm.defaultFlag ? 1 : 0,
							remark: that.ruleForm.remark,
							sapNo: that.ruleForm.sapNo,
							barcode: that.ruleForm.barcode,
							format: that.ruleForm.format
						}
					)
					.then((res) => {
						if (res) {
							that.dialogVisible = false
							that.$message.success("保存成功！");
							that.$emit("getList")
						}

					})
			},
			// 修改
			updateRow() {
				let that = this;
				that.$request.post(
						"skuUpdate",
						true, {
							skuId: that.ruleForm.skuId,
							skuName: that.ruleForm.skuName,
							skuFullName: that.ruleForm.skuFullName,
							skuCode: that.ruleForm.skuCode,
							skuColor: that.ruleForm.skuColor,
							defaultFlag: that.ruleForm.defaultFlag ? 1 : 0,
							remark: that.ruleForm.remark,
							sapNo: that.ruleForm.sapNo,
							barcode: that.ruleForm.barcode,
							format: that.ruleForm.format
						}
					)
					.then((res) => {
						if (res) {
							that.dialogVisible = false
							that.$message.success("保存成功！");
							that.$emit("getList")
						}
					})
			},
			// 取消
			cancle() {
				this.dialogVisible = false
				this.$refs['ruleForm'].resetFields();
			},

		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.mb0 {
		margin-bottom: 0 !important;

		/deep/ .el-form-item__content {
			line-height: 0 !important;
		}
	}

</style>
